<template>
	<div id="move-job-list">
		<b-table striped hover selected-variant="success" selectable select-mode="single" sticky-header="true" small :fields="fields" :items="jobs"
				 @row-selected="onRowSelected" responsive="sm">
			<template v-slot:cell(id)="data">
				{{ data.item.fieldData['__PKJobID'] }}
			</template>
			<template v-slot:cell(name)="data">
				{{ data.item.fieldData['Job Name'] }}
			</template>
			<template v-slot:cell(expiration)="data">
				{{ data.item.fieldData['Registration::Expiration Date'] }}
			</template>
			<template v-slot:cell(registration)="data">
				{{ data.item.fieldData['Registration::Registration Number'] }}
			</template>
		</b-table>
	</div>
</template>

<script>
import moment from 'moment'
import feedbackMixin from "../../mixins/feedback";
import {EventBus} from "../../event-bus";

export default {
	name: 'MoveJobList',
	mixins: [feedbackMixin],
	data() {
		return {
			fields: [
				{key: 'id', label: 'ID'},
				/*{key: 'job id', label: 'Job ID'},*/
				{key: 'expiration', label: 'Expiration'},
				{key: 'registration', label: 'Registration'},
				{key: 'name', label: 'Name'},
			],
			jobs: []
		}
	},
	methods: {
		getMatchingJobs(regNo) {
			let currentDate = moment().format('MM/DD/YYYY');

			this.axios('/3ds/api/jobs', {
				method: 'get',
				headers: {
					'Authorization': 'Bearer ' + this.token
				},
				params: {
					query: {
						offset: null,
						limit: null,
						search: true,
						searchCriteria: [
							{
								omit: false,
								criteria: {
									'Registration::Expiration Date': '>=' + currentDate,
									'Registration Number': regNo,
									'Locked Job': 'No'
								}
							}
						]
					}
				}
			})
				.then(value => {
					console.log('Successfully retrieved matching jobs');
					console.log(JSON.stringify(value));
					this.jobs = value.data.data
				})
		},
		onRowSelected(rows) {
			//Since select-mode is 'single,' we get first and only row
			if (rows.length > 0) {
				let row = rows[0];
				console.log("Job ID " + row.fieldData['__PKJobID']);
				EventBus.$emit('job-selected', {
					job_id: row.fieldData['__PKJobID']
				})
			} else {
				EventBus.$emit('job-selected', {
					job_id: ''
				})
			}
		}
	},
	mounted() {
		this.getMatchingJobs(this.registration)
	},
	props: {
		registration: {
			type: String
		},
	},
}
</script>

<style scoped>
#move-job-list >>> .table-hover tbody tr:hover {
    background-color: rgba(184, 218, 255, 0.5);
}

#move-job-list >>> .table-success {
	background-color: rgb(131, 186, 35);
}
</style>